import { requestBuilder } from '../../../http/RequestBuilder';

interface UseCreatePermanentAccessTokenResponse {
    customer_id: string;
    request_id: string;
    vendor_access_token: string;
    vendor_customer_id: string;
    vendor_institution_id: string;
    vendor_public_token: string;
}

interface UseCreatePermanentAccessTokenBody {
    stytchId: string;
    vendorInstitutionId: string;
    vendorPublicToken: string;
}

const useCreatePermanentAccessToken = requestBuilder.mutation<
    UseCreatePermanentAccessTokenResponse,
    UseCreatePermanentAccessTokenBody
>({
    endpoint: '/api/external-account/permanent-access-token',
    method: 'POST',
});

export default useCreatePermanentAccessToken;
